//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const Immunization = createAsyncThunk(
  "Immunization",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingImmunization(""));
      const response = await UsePortalApi(
        `Patient/Immunization`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingImmunizationSuccess(response[0].entry)) : dispatch(gettingImmunizationClear())

      } else {
        dispatch(
          gettingImmunizationFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingImmunizationFailed(error));
    }
  }
);
// export const fetchMoreImmunefromApi = (pageSize, pageNumber) => {
//     return (dispatch) => {
//         dispatch(getImmune())
//         getUserId().then((userInfo) => {
//             const item = JSON.parse(userInfo);
//             const queryString = '?Token=' + item.token + '&PatientID='+item.userid+'&PageSize='+pageSize+'&PageNumber='+pageNumber+'&TypeID=0'
//             getAllImmune(queryString)
//                 .then(data => data.json())
//                 .then(json => {
//                     json[0].hasOwnProperty('entry') ? dispatch(getImmuneMoreSuccess(json[0].entry)) : dispatch(gettingImmunizationClear())
//                 })
//                 .catch(err => dispatch(getImmuneFail(err)))
//         })
//     }
// }

const ImmunizationSlice = createSlice({
  name: "Immunization",
  initialState: {
    Immune: null,
    isGettingImmune: false,
    immuneError: false,
  },
  reducers: {
    gettingImmunization: (state, action) => {
      state.Immune = null;
      state.isGettingImmune = true;
      state.immuneError = false;
    },
    gettingImmunizationSuccess: (state, action) => {
      state.Immune = action.payload;
      state.isGettingImmune = false;
      state.immuneError = false;
    },
    gettingImmunizationFailed: (state, action) => {
      state.Immune = null;
      state.isGettingImmune = false;
      state.immuneError = true;
    },
    gettingImmunizationClear: (state, action) => {
      state.Immune = null;
      state.isGettingImmune = false;
      state.immuneError = false;
    },
  },
});
export const {
  gettingImmunization,
  gettingImmunizationSuccess,
  gettingImmunizationFailed,
  gettingImmunizationClear,
} = ImmunizationSlice.actions;
export default ImmunizationSlice.reducer;
